// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "h3[data-v-6e0d791a]{font-size:1.25rem;line-height:1.94rem;font-weight:500;margin-top:.5rem}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
